import React from "react";
import { useTranslation } from "react-i18next";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

interface AddressInputProps {
  id?: string;
  value: string;
  onChange: (address: string) => void;
  onSelect?: (address: string, coords?: { lat: number; lng: number }) => void;
  placeholder?: string;
  name?: string;
  required?: boolean;
}

const AddressInput: React.FC<AddressInputProps> = ({
  id,
  value,
  onChange,
  onSelect,
  placeholder,
  name,
  required = false,
}) => {
  const { t } = useTranslation();

  return (
    <PlacesAutocomplete
      value={value}
      onChange={onChange}
      onSelect={(address) => {
        if (onSelect) {
          geocodeByAddress(address)
            .then((results) => getLatLng(results[0]))
            .then((coords) => onSelect(address, coords))
            .catch(() => onSelect(address));
        } else {
          onChange(address);
        }
      }}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div className="relative">
          <input
            {...getInputProps({
              id,
              placeholder: placeholder || t("addressInput.placeholder"),
              name,
              required,
              className:
                "w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm transition-all focus:border-primary focus:ring-2 focus:ring-primary/20 focus:outline-none",
            })}
          />
          {(loading || suggestions.length > 0) && (
            <div className="autocomplete-dropdown-container">
              {loading && (
                <div className="px-4 py-3 text-xs text-muted">
                  {t("addressInput.loading")}
                </div>
              )}
              {suggestions.map((s) => (
                <div
                  {...getSuggestionItemProps(s, {
                    className: s.active
                      ? "suggestion-item--active"
                      : "suggestion-item",
                  })}
                >
                  {s.description}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export default AddressInput;
